import { Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { useTranslateListAll } from './useTranslateList';

export const LanguageSelector = (props: any) => {
  const langList = useTranslateListAll();
  const { t, i18n } = useTranslation();
  return (
    <div className="container">
      <Row>
        <Col xs="10"></Col>
        <Col>
          <Form.Control
            onChange={(e) => {
              i18n.changeLanguage(e.target.value);
            }}
            name="type"
            as="select"
            value={i18n.language}
          >
            {langList.map((def: any) => {
              if (def.id) {
                return <option key={def.id}>{def.name}</option>;
              }
            })}
          </Form.Control>
        </Col>
      </Row>
    </div>
  );
};
